import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { IosInstallCode } from '@/models/codes/codes.model';

export interface CodesRepository {
  getAppUrl(store: string): Observable<IosInstallCode>;
}

export const CODES_REPOSITORY = new InjectionToken<CodesRepository>('CODES_REPOSITORY');
